/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedSkyscraperAd_itemSearch$ref = any;
export type SbSharedSkyscraperAd_itemSearch = {
    readonly displayUriRef: string | null;
    readonly " $refType": SbSharedSkyscraperAd_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedSkyscraperAd_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayUriRef",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'ab9bd5f5f1352deba7eff180c5e8ee97';
export default node;
